import React from 'react'
import { BroadbandSummaryIcon, PhoneSummaryIcon } from './Icons';

const sideIcons = {
    marginRight: '1rem'
}

export default function SidebarBroadbandSummary(props) {
    const handleEdit = (editStep) =>{
        props.editFunction(editStep);
    }
    
    const displaySummary = () => {
        if (props.values.broadbandArray.sort() instanceof Array && props.values.broadbandArray.sort().length !== 0) {
            console.log(props.values);

            return props.values.broadbandArray.sort().map((service, index) => {
                const uniqueKey = `${service}-${index}`;
                return (
                    <div key={uniqueKey}>
                        {service === 'broadband' ? (
                            <React.Fragment>
                                <h5 className="h5 primary" key={`${service}-header`}>
                                    <div className="service-icon service-icon-sidebar">
                                        <BroadbandSummaryIcon />
                                    </div> 
                                    {service.toUpperCase()}
                                </h5>
                            </React.Fragment>
                        ) : (props.values.selectPhone === 'Yes' && props.values.confirmPhonePlan.length > 0) && (
                            <React.Fragment>
                                <h5 className="h5 primary" key={`${service}-header`}>
                                    <div className="service-icon service-icon-sidebar">
                                        <PhoneSummaryIcon />
                                    </div> 
                                    HOME PHONE
                                </h5>
                            </React.Fragment>
                        )}
                        <table key={`${service}-table`}>
                            <tbody style={{border:'none'}}>
                                {service === 'broadband' && props.values.broadbandPlan.map((item, i) => {
                                    const broadbandKey = `${item.plan}-${i}`;
                                    return (
                                        <React.Fragment key={broadbandKey}>
                                            <tr>
                                                <td style={{paddingLeft:'0', width: "180px"}}>{item.plan}: {props.values.connectionOption}</td>
                                                <td align="right" style={{display:'flex'}}>{item.price} /month</td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                })}
                                
                                {service === 'phone' && props.values.selectPhone === 'Yes' && props.values.confirmPhonePlan.map((item, i) => {
                                    if (item.title === 'undefined') {
                                        return '';
                                    }
                                    const phoneKey = `${item.title}-${i}`;
                                    return (
                                        <React.Fragment key={phoneKey}>
                                            <tr>
                                                <td style={{paddingLeft:'0', width: "180px"}}>{item.title}</td>
                                                <td align="right">{item.price} /month</td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                );
            });
        } else {
            return null;
        }
    }

    return (
        <div className="col-12 d-none d-sm-none d-md-block d-lg-block" id="sideBarBroadbandSummary">
            <div className="row">
                <div className="col-10" style={{marginBottom:"2rem"}}><h4 className="h4 primary">Your Broadband Plan</h4></div> 
                {/* <div className="col-2 text-right">  
                    { props.values.canEdit  &&<span href="#" style={{cursor:"pointer"}} id="editButton" onClick={e=>handleEdit(8)}>Edit</span>}
                </div> */}
                <div className="col-12" >                 
                    {displaySummary()}
                    <div style={{marginTop:"2rem"}}></div>
                </div>
            </div>
        </div>
    )
}